import axios from "axios";
import { CommonTexts as Texts } from "../helpers/LayoutTexts";
import { Degree } from "../models/Degree";
import { DegreeSearchCriteria } from "../models/DegreeSearchCriteria";

export async function getStateUniversities(adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-degrees/universities-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getStateFaculties(universityId: number = -1, adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-degrees/faculties-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                universityId: universityId,                
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getStateDegrees(universityId: number = -1, facultyId: number = -1, keyword: string = "", adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-degrees/degrees-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                universityId: universityId,
                facultyId: facultyId,
                keyword: keyword,
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getStateDegree(degreeId: number, adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-degrees/degree-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                degreeId: degreeId,
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function editStateDegree(degree: Degree, adminId: number, token: string) {          
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(Texts.apiBaseUrl + "state-degrees/degree-edit-by-admin", degree, {
            headers: {
              'Content-Type': 'application/json',              
              'Authorization' : `Bearer ${token}`
            },
            params: {
                adminId: adminId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getPrivateDegreeSearchOptions() {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "private-degrees/degree-search-options", {                       
            params: {                
                languageCode: "SIN"
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getPrivateDegrees(model: DegreeSearchCriteria) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "private-degrees/degree-search-results-by-admin", {            
            params: model
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getPrivateDegree(degreeId: number, adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "private-degrees/degree-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                degreeId: degreeId,
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function editPrivateDegree(degree: Degree, adminId: number, token: string) {          
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(Texts.apiBaseUrl + "private-degrees/degree-edit-by-admin", degree, {
            headers: {
              'Content-Type': 'application/json',              
              'Authorization' : `Bearer ${token}`
            },
            params: {
                adminId: adminId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}